// removed by extract-text-webpack-plugin
module.exports = {"loader":"_-src-components-UserSegments-components-List-index---loader---3sqxt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserSegments/components/List/index.css
// module id = 677
// module chunks = 1